
<template>
  <div id="app">
    <!-- 路由视图组件 -->
    <router-view />
    <!-- 在线客服组件 -->
    <!-- <OnlineService /> -->
  </div>
</template>

<script>
// import OnlineService from '@/components/OnlineService.vue'

export default {
  name: 'App',
  components: {
    // OnlineService
  }
}
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

#app {
  height: 100%;
}
</style>